import 'slick-carousel';
import 'isotope-layout/dist/isotope.pkgd';

const jQueryBridget = require('jquery-bridget');
const Isotope = require('isotope-layout');
// make Isotope a jQuery plugin
jQueryBridget( 'isotope', Isotope, $ );

const Vivus = require('vivus/dist/vivus');

const imagesLoaded = require('imagesloaded');
// provide jQuery argument
imagesLoaded.makeJQueryPlugin( $ );


(function($) {
	var $headerSlider = $('.block-header-wrapper__slider');
	// create vivus object on init/change
	$headerSlider.on('init reInit afterChange', function(event, slick, currentSlide) {
		var svgID = "slider-svg-"+(currentSlide ? currentSlide : 0);
		var svgUrl = $('#'+svgID).data('svg');
		var type = $('#'+svgID).data('type');
		var duration = $('#'+svgID).data('duration');
		var delay = $('#'+svgID).data('delay');

		new Vivus(svgID, { type: type, start: 'autostart', duration: duration, delay: delay, file: svgUrl, onReady: function (myVivus) {
				$('#'+svgID).parent().addClass('current');
		} });
	});

	// remove current slider svg before change
	$headerSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
		var currentSvgID = "slider-svg-"+currentSlide;
		$('#'+currentSvgID).fadeOut(500, function() {
			$(this).empty().show();
		});
		$('#'+currentSvgID).parent().removeClass('current');
	});

	$headerSlider.slick({
		autoplay: true,
		autoplaySpeed: 7500,
		dots: false,
		arrows: false,
		infinite: true,
		speed: 1300,
		fade: true,
		draggable: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		cssEase: 'ease-in-out',
		pauseOnFocus: false,
		pauseOnHover: false,
		swipe: false,
	});


	$('.hamburger').click(function() {
		$(this).toggleClass('is-active');

		$('.nav-main').toggleClass('show');
	});

	$('.menu-item-has-children > a').click(function(e) {
		e.preventDefault();

		var menu = $(this).parent(),
			wrapper = menu.parent();

		if(menu.hasClass('show')) {
			menu.removeClass('show');
			wrapper.removeClass('active');
		} else {
			menu.parent().find('.menu-item-has-children.show').removeClass('show');
			menu.addClass('show');
			wrapper.addClass('active');
		}
	});

	$('.menu-back').click(function(e) {
		e.preventDefault();

		var menu = $(this).parent().parent('.menu-item-has-children.show'),
			wrapper = menu.parent();

		menu.removeClass('show');
		wrapper.removeClass('active');
	});

	// Scroll function to header
	function setScrolledClass() {
		var body = $('body');
		if($(document).scrollTop() > 50 && !body.hasClass('scrolled')){
			body.addClass('scrolled');
		}

		if($(document).scrollTop() <= 50 && body.hasClass('scrolled')){
			body.removeClass('scrolled');
		}
	}
	$(window).scroll(function() {
		setScrolledClass();
	});
	$(document).ready(function() {
		setScrolledClass();
	});

	$(document).ready(function () {

		$('.ensembles').imagesLoaded(function() {
			$('.ensembles').isotope({
				// options
				itemSelector: '.ensembles__item',
				layoutMode: 'masonry',
			});
		});

		$('.instruments').imagesLoaded(function() {
			$('.instruments').isotope({
				// options
				itemSelector: '.instruments__item',
				layoutMode: 'masonry',
			});
		});

		// bind sort button click
		$('.filter__item input').change(function(){
			var catName = $(this).data('category'),
				catID = catName + '-filter',
				catWrapper = '#' + catID,
				catVal = $(this).val(),
				filterVal = '';

			// check or uncheck "all"
			if(catVal === catName + '-all') {
				$(catWrapper).find('input').not($(this)).prop( "checked", false );
			} else {
				$('#' + catID).find('input[value="' + catName + '-all"]').prop( "checked", false );
			}
			if($(catWrapper).find('input:checked').length == 0) {
				$('#' + catID).find('input[value="' + catName + '-all"]').prop( "checked", true );
			}

			// filter
			if($('#ac-filter').length > 0) {
				$('#ac-filter').find('input:checked').each(function () {
					const ac = $(this).val();
					$('#types-filter').find('input:checked').each(function () {
						filterVal = filterVal + '.' + ac + '.' + $(this).val() + ', ';
					});
				});

				$('.ensembles').isotope({
					// options
					itemSelector: '.ensembles__item',
					filter: filterVal.substring(0, filterVal.length - 2),
					layoutMode: 'masonry',
				});
			}

			if($('#ic-filter').length > 0) {
				$('#ic-filter').find('input:checked').each(function () {
					filterVal = filterVal + '.' + $(this).val() + ', ';
				});

				$('.instruments').isotope({
					// options
					itemSelector: '.instruments__item',
					filter: filterVal.substring(0, filterVal.length - 2),
					layoutMode: 'masonry',
				});
			}

		});


		var urlHash = $(location).attr('hash');
		urlHash = urlHash.substring(1, urlHash.length);
		if($('#ac-' + urlHash).length > 0) {
			$('#ac-' + urlHash).click();
		}
		if($('#ic-' + urlHash).length > 0) {
			$('#ic-' + urlHash).click();
		}
		if($('#types-' + urlHash).length > 0) {
			$('#types-' + urlHash).click();
		}
	});

})( jQuery );
